export default [
  {
    path: '/ir',
    name: 'income_tax',
    component: () => import('./IncomeTax.vue'),
    meta: {
      pageSection: 'Funcionários',
      pageTitle: 'Imposto de Renda',
      auth: true,
      user: 'Admin',
    },
  },
]
